import { IReferralCreatorParams } from 'Interfaces/SelfServiceReferrals';
import { ReferralCategory } from 'Interfaces/SelfServiceReferrals';

export const buildReferralCreatorParams = (
  props: IReferralCreatorParams,
): IReferralCreatorParams => ({
  institutionName: props.institutionName,
  departmentName: props.departmentName,
  category: props.category,
  itemId: props.itemId,
  hospitalId: props.hospitalId,
  departmentId: props.departmentId,
  medicalSectorId: props.medicalSectorId,
  supplierId: props.supplierId,
  paramTableTableKey: props.paramTableTableKey,
  paramsTableValue: props.paramsTableValue,
  institutionPhone: props.institutionPhone,
  subject: props.subject,
  isFamilyMental: props.isFamilyMental,
  familyMemberIsraeliId: props.familyMemberIsraeliId,
  recipientName: props.recipientName,
  contactDepartmentUrl: props.contactDepartmentUrl,
});

export const buildReferralTrackingSubtitle = (
  params: IReferralCreatorParams,
  mentalSubjectSuffix: string,
): string => {
  if (params.isFamilyMental && params.recipientName) {
    return `${mentalSubjectSuffix} | ${params.recipientName}`;
  }

  const serviceName =
    params.subject || params.departmentName || params.institutionName || '';

  if (params.category === ReferralCategory.Mental) {
    return `${mentalSubjectSuffix} | ${params.institutionName}`;
  }

  if (params.category === ReferralCategory.Equipment) {
    const itemName = params.departmentName || params.subject || '';
    return itemName && params.institutionName
      ? `${itemName} | ${params.institutionName}`
      : params.institutionName || itemName;
  }

  return serviceName
    ? `${serviceName} | ${params.institutionName}`
    : params.institutionName;
};

export const buildReferralFailedDetailsLine = (
  params: IReferralCreatorParams,
  mentalSubjectSuffix: string,
): string => {
  if (params.category === ReferralCategory.Mental) {
    return `${mentalSubjectSuffix} | ${params.institutionName}`;
  }

  const serviceName = params.subject || params.departmentName || '';
  return serviceName
    ? `${serviceName} | ${params.institutionName}`
    : params.institutionName;
};
